import { Box, Typography } from "@mui/material";
import { useHusibuechContext } from "../context/husibuechContext";

// used for App Bar
export const HusibuechAppTitle = () => {
  const { husibuechLoading } = useHusibuechContext();

  return (
    <div>
      <div
        style={{
          width: "110%",
          whiteSpace: "nowrap", // Prevent content from wrapping
        }}
      >
        <Typography variant="h6" color="primary">
          KSB
        </Typography>
      </div>
      <>
        <div
          style={{
            width: "110%",
            whiteSpace: "nowrap", // Prevent content from wrapping
          }}
        >
          <Typography color="primary" variant="h4" fontWeight={"bold"}>
            Husibuech
          </Typography>
        </div>
        <div
          style={{
            width: "110%",
            whiteSpace: "nowrap", // Prevent content from wrapping
          }}
        >
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              pt: 0,
            }}
          >
            <Typography color="primary" variant="caption">
              {husibuechLoading ? "wir laden Daten" : "Wir sind bereit"}
            </Typography>
          </Box>
        </div>
      </>
    </div>
  );
};
